import { useContext, useState } from "react";
import "./SupervisorHome.css";
import Header from "../header/Header";
import Sidebar from "../supervisor_home/sidebar/Sidebar";
import TaskSummary from "../supervisor_home/task-summary/TaskSummary";
import AddUser from "../supervisor_home/AddUser";
import RecentEntries from "../supervisor_home/recent/RecentEntries";

import FormProvider from "../../context/FormContext";

const SupervisorHome = () => {
  const { isFormOpen } = useContext(FormProvider);
  const [claimFilter, setClaimFilter] = useState() 

  return (
    <div
      className={
        isFormOpen ? "main-form-container" : "main-supervisor-container"
      }
    >
      <Header />
      <Sidebar />
      <TaskSummary setClaimFilter={setClaimFilter} />
      <AddUser />
      <RecentEntries claimFilter={claimFilter} setClaimFilter={setClaimFilter}/>
    </div>
  );
};

export default SupervisorHome;
